/* Looma — tiroir panier natif (2026-10-19). Actif seulement si window.LMO_NATIVE (voir snippets/lmo-native-cart.liquid).
   1. minuteur « Your cart expires in » (fin mémorisée dans localStorage, relancée à 10 min si dépassée) ;
   2. bouton « Add » des upsells : /cart/add.js + rerendu du tiroir Dawn. */
(function () {
  /* Mode checkout direct (window.LMO_DIRECT) : actif même si le tiroir natif ne sert plus. Les fiches avec bundle (.lmb) gèrent leur propre ajout (lmo-bundle.js). */
  if (window.LMO_DIRECT) {
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('#cart-icon-bubble') : null;
      if (!a) return;
      e.preventDefault(); e.stopImmediatePropagation();
      location.href = '/cart';
    }, true);
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.action || form.action.indexOf('/cart/add') < 0 || document.querySelector('.lmb[data-lmb]')) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var fd = new FormData(form), body = { items: [{ id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity') || '1', 10) || 1 }] };
      fd.forEach(function (v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m) { body.items[0].properties = body.items[0].properties || {}; body.items[0].properties[m[1]] = v; } });
      if (fd.get('selling_plan')) body.items[0].selling_plan = fd.get('selling_plan');
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { if (!r.ok) throw new Error(r.status); location.href = '/checkout'; })
        .catch(function () { form.submit(); });
    }, true);
  }
  if (!window.LMO_NATIVE) return;
  var CFG = window.LMO_NATIVE_CFG || {};
  var KEY = 'lmoTimerEnd';

  function endTime() {
    var end = 0;
    try { end = parseInt(localStorage.getItem(KEY), 10) || 0; } catch (e) {}
    if (end < Date.now()) {
      end = Date.now() + (CFG.timerMinutes || 10) * 60000;
      try { localStorage.setItem(KEY, String(end)); } catch (e) {}
    }
    return end;
  }
  function tick() {
    var nodes = document.querySelectorAll('[data-lmo-cart-timer-value]');
    if (!nodes.length) return;
    var left = Math.max(0, Math.round((endTime() - Date.now()) / 1000));
    var txt = String(Math.floor(left / 60)).padStart(2, '0') + ':' + String(left % 60).padStart(2, '0');
    nodes.forEach(function (n) { n.textContent = txt; });
  }
  setInterval(tick, 1000);
  document.addEventListener('DOMContentLoaded', tick);


  /* Ouverture immédiate du tiroir avec un voile « Adding to your cart… » : les 3 appels panier (vider, remise, ajout) + le rendu prennent ~1,5 s,
     on ne fait plus attendre le client devant une page figée. renderContents() remplace le contenu, donc le voile disparaît tout seul. */
  window.lmoOpenLoading = function () {
    var d = document.querySelector('cart-drawer');
    if (!d || !d.open) return;
    var inner = d.querySelector('.drawer__inner');
    if (inner && !inner.querySelector('.lmo-nc-loading')) {
      var o = document.createElement('div');
      o.className = 'lmo-nc-loading';
      o.innerHTML = '<span class="lmo-spin"></span><span>Adding to your cart\u2026</span>';
      inner.appendChild(o);
    }
    d.classList.remove('is-empty');
    d.open();
  };
  window.lmoCloseLoading = function () {
    var d = document.querySelector('cart-drawer');
    if (!d) return;
    var o = d.querySelector('.lmo-nc-loading'); if (o) o.remove();
    if (d.close) d.close();
  };

  /* Recommandations Shopify (moteur de recommandation de la boutique) pour les produits sans liste fixe : complémentaires d'abord, puis liées. */
  function recCard(p, inCart) {
    var v = (p.variants || []).filter(function (x) { return x.available; })[0];
    if (!v) return '';
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var price = Math.round(parseFloat(v.price) * (String(v.price).indexOf('.') >= 0 ? 100 : 1));
    var cmp = v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * (String(v.compare_at_price).indexOf('.') >= 0 ? 100 : 1)) : 0;
    var fmt = function (c) { try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(c / 100); } catch (e) { return (c / 100).toFixed(2); } };
    var esc = function (s) { return String(s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); };
    return '<div class="lmo-nc-up__item"><a href="' + esc(p.url) + '" class="lmo-nc-up__img"><img src="' + esc(img) + '" alt="' + esc(p.title) + '" width="148" height="148" loading="lazy"></a>' +
      '<div class="lmo-nc-up__info"><a href="' + esc(p.url) + '" class="lmo-nc-up__name">' + esc(p.title) + '</a><div class="lmo-nc-up__price"><strong>' + fmt(price) + '</strong>' + (cmp > price ? ' <s>' + fmt(cmp) + '</s>' : '') + '</div></div>' +
      (inCart ? '<button type="button" class="lmo-nc-up__btn is-in" disabled>In cart \u2713</button>' : '<button type="button" class="lmo-nc-up__btn" data-lmo-upsell="' + v.id + '">Add</button>') + '</div>';
  }
  function fillRecs() {
    document.querySelectorAll('[data-lmo-recs]:not([data-lmo-done])').forEach(function (box) {
      box.setAttribute('data-lmo-done', '1');
      var id = box.getAttribute('data-lmo-recs'), have = (box.getAttribute('data-cart-pids') || '').split(',');
      function get(intent) { return fetch('/recommendations/products.json?product_id=' + id + '&limit=6&intent=' + intent).then(function (r) { return r.ok ? r.json() : { products: [] }; }).then(function (j) { return j.products || []; }).catch(function () { return []; }); }
      get('complementary').then(function (a) { return a.length >= 3 ? a : get('related').then(function (b) { var seen = {}; return a.concat(b).filter(function (p) { if (seen[p.id]) return false; seen[p.id] = 1; return true; }); }); })
        .then(function (list) {
          var html = list.filter(function (p) { return String(p.id) !== String(id); }).slice(0, 6).map(function (p) { return recCard(p, have.indexOf(String(p.id)) >= 0); }).join('');
          if (html) box.innerHTML = html; else { var up = box.closest('.lmo-nc-up'); if (up) up.remove(); }
        });
    });
  }
  /* La barre de livraison offerte glisse de l'ancienne valeur à la nouvelle (le tiroir est re-rendu côté serveur à chaque changement). */
  var prevPct = null;
  function animateBar() {
    var f = document.querySelector('cart-drawer .lmo-nc-bar__fill[data-pct]');
    if (!f) return;
    var to = parseFloat(f.getAttribute('data-pct')) || 0;
    if (prevPct !== null && prevPct !== to && !f.__lmoAnim) {
      f.__lmoAnim = true;
      f.style.width = prevPct + '%';
      requestAnimationFrame(function () { requestAnimationFrame(function () { f.style.width = to + '%'; }); });
    }
    prevPct = to;
  }
  /* Cadeau orphelin : si plus aucun article payant, les lignes à 0 $ (guide, e-book…) sont retirées pour ne pas laisser un panier « gratuit ». */
  var clearing = false;
  function cleanOrphanGifts() {
    var d = document.querySelector('cart-drawer');
    if (!d || clearing) return;
    if (!d.querySelector('.cart-item.lmo-free') || d.querySelector('.cart-item:not(.lmo-free)')) return;
    clearing = true;
    fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
      .then(function () { return fetch('/?sections=cart-drawer,cart-icon-bubble'); })
      .then(function (r) { return r.json(); })
      .then(function (sections) { if (d.renderContents) { d.renderContents({ sections: sections }); } })
      .catch(function () {})
      .then(function () { clearing = false; });
  }
  /* classe html.lmo-cart-open tant que le tiroir est ouvert (voir lmo-native-cart.css : page masquée derrière) */
  function syncOpen() {
    var d = document.querySelector('cart-drawer');
    document.documentElement.classList.toggle('lmo-cart-open', !!(d && d.classList.contains('active')));
  }
  (function () {
    var d = document.querySelector('cart-drawer');
    if (d) new MutationObserver(syncOpen).observe(d, { attributes: true, attributeFilter: ['class'] });
    syncOpen();
  })();
  var dr = document.querySelector('cart-drawer');
  if (dr) new MutationObserver(function () { fillRecs(); animateBar(); cleanOrphanGifts(); }).observe(dr, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', fillRecs);
  fillRecs();

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-lmo-upsell]') : null;
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var id = parseInt(btn.getAttribute('data-lmo-upsell'), 10);
    var drawer = document.querySelector('cart-drawer');
    btn.disabled = true;
    btn.textContent = '…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble' })
    }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (res) { if (drawer && drawer.renderContents) { drawer.classList.remove('is-empty'); drawer.renderContents(res); } else location.reload(); })
      .catch(function () { btn.disabled = false; btn.textContent = 'Add'; });
  });
})();
